import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { UserIcon } from '@shared/assets/icons';
import { withTheme } from '@shared/lib/theme';
const UserAvatar: FC = () => <UserAvatarWrapper>
    <UserIcon />
  </UserAvatarWrapper>;
export default UserAvatar;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.stroke.active;
const UserAvatarWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "UserAvatarWrapper",
  class: "u15gh71o",
  propsAsIs: false,
  vars: {
    "u15gh71o-0": [_exp()],
    "u15gh71o-1": [_exp2()]
  }
}));

require("./UserAvatar.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./UserAvatar.tsx");